import passengersReducer from './passengersReducer';

export default passengersReducer;
